import { useEffect, useMemo, useState } from "react";
import LorsHero from "@/components/landing/lors/LorsHero";
import LorsTestimonials from "@/components/landing/lors/LorsTestimonials";
import LorsAbout from "@/components/landing/lors/LorsAbout";
import LorsRegistration from "@/components/landing/lors/LorsRegistration";
import LorsFooter from "@/components/landing/lors/LorsFooter";
import LorsStickyCta from "@/components/landing/lors/LorsStickyCta";
import { lorsContentAug27, aug27Headlines } from "@/components/landing/lors/translationsSep10";
import { captureUtmsFromUrl } from "@/components/landing/lors/utmStorage";

const REDIRECT_TO = "/september-10-2026/ty";

const Aug272026 = () => {
  const [lang] = useState<"en">("en");

  useEffect(() => {
    captureUtmsFromUrl();
  }, []);

  useEffect(() => {
    const prev = document.documentElement.lang;
    document.documentElement.lang = "en";
    return () => {
      document.documentElement.lang = prev;
    };
  }, []);

  const copy = useMemo(() => {
    const base = lorsContentAug27["en"];
    const params = new URLSearchParams(window.location.search);
    const n = Number(params.get("h"));
    if (!Number.isInteger(n) || n < 1 || n > aug27Headlines.length) return base;
    const pick = aug27Headlines[n - 1];
    return { ...base, headline: pick, headlineBreakBefore: undefined } as typeof base;
  }, []);

  return (
    <main className="lors-theme">
      <LorsHero copy={copy} redirectTo={REDIRECT_TO} formKey="sep10" />
      <LorsTestimonials copy={copy} lang={lang} />
      <LorsAbout copy={copy} />
      <LorsRegistration copy={copy} />
      <LorsFooter copy={copy} />
      <LorsStickyCta copy={copy} />
    </main>
  );
};

export default Aug272026;
